// extracted by mini-css-extract-plugin
export var activeDot = "_3p-c";
export var buttonContainer = "_3p-9";
export var channelButton = "_3p-a";
export var clickable = "_3p-d";
export var content = "_3p-0";
export var contentFull = "_3p-2";
export var contentThird = "_3p-1";
export var contentWrapper = "_3p-7";
export var description = "_3p-5";
export var heightShort = "_3p-f";
export var image = "_3p-3";
export var imageContainer = "_3p-4";
export var selectButton = "_3p-e";
export var spinnerContainer = "_3p-b";
export var titleContent = "_3p-8";
export var titleWrapper = "_3p-6";